import { render, staticRenderFns } from "./organizationOperation.vue?vue&type=template&id=1d96fe92&scoped=true"
import script from "./organizationOperation.vue?vue&type=script&lang=js"
export * from "./organizationOperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96fe92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d96fe92')) {
      api.createRecord('1d96fe92', component.options)
    } else {
      api.reload('1d96fe92', component.options)
    }
    module.hot.accept("./organizationOperation.vue?vue&type=template&id=1d96fe92&scoped=true", function () {
      api.rerender('1d96fe92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/organizationManage/organizationOperation.vue"
export default component.exports